import React from 'react';
import PropTypes from 'prop-types';
import './Popup.css';

import { useDispatch } from "react-redux";
import { setPopup } from "../../../actions/index";

function Popup({ content = null, className = 'popup-side', style, outsideClick = true }) {
  const dispatch = useDispatch();
  const disablePopup = () => { dispatch(setPopup({ content: null })); };
  const clickParent = (clickOutside) => (e) => {
    if (!clickOutside) { return; }
    if (e.target !== e.currentTarget) { return; }
    disablePopup();
  }
  return content ? (
    <div className={`popupv2 flexColumn ${className}`} style={style} onClick={clickParent(outsideClick)} >
      { React.cloneElement(content, { cancelClick: disablePopup }) }
    </div>
  ) : null
}

Popup.propTypes = {
  content: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object
}

export default Popup;
